<template>
  <div class="tagged-progress-bar-container">
    <div class="tagged-progress-bar">
      <div
        class="tagged-progress-bar-fill red"
        :style="{ flex: displayedRed }"
      ></div>
      <div
        class="tagged-progress-bar-fill yellow"
        :style="{ flex: displayedYellow }"
      ></div>
      <div
        class="tagged-progress-bar-fill green"
        :style="{ flex: displayedGreen }"
      ></div>
      <div
        class="tagged-progress-bar-fill primary"
        :style="{ flex: displayedBookmarked }"
      ></div>
      <div
        class="tagged-progress-bar-fill remaining"
        :style="{ flex: displayedRemaining }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 1,
    },
    red: {
      type: Number,
      default: 0,
    },
    yellow: {
      type: Number,
      default: 0,
    },
    green: {
      type: Number,
      default: 0,
    },
    bookmarked: {
      type: Number,
      default: 0,
    },
    filter: {
      type: String,
      default: 'unanswered',
    },
    unanswered: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    calculatedTotal() {
      if (this.total) {
        return this.total;
      }
      return this.answered + this.unanswered;
    },
    displayedRed() {
      if (this.filter === 'red') {
        return this.red;
      }
      if (this.filter === 'unanswered') {
        return this.red;
      }
      return 0;
    },
    displayedYellow() {
      if (this.filter === 'yellow') {
        return this.yellow;
      }
      if (this.filter === 'unanswered') {
        return this.yellow;
      }
      return 0;
    },
    displayedGreen() {
      if (this.filter === 'green') {
        return this.green;
      }
      if (this.filter === 'unanswered') {
        return this.green;
      }
      return 0;
    },
    displayedBookmarked() {
      if (this.filter === 'bookmarked') {
        return this.bookmarked;
      }
      return 0;
    },
    displayedRemaining() {
      return this.calculatedTotal - this.totalDisplayed;
    },
    totalDisplayed() {
      return this.displayedRed + this.displayedYellow + this.displayedGreen + this.displayedBookmarked;
    },
  },
};
</script>

<style scoped lang="scss">
.tagged-progress-bar {
  border-radius: var(--radius-md);
  display: flex;
  height: 6px;
  overflow: hidden;
  width: 100%;

  @include breakpoint(tablet) {
    width: rem-calc(249);
  }

  @include breakpoint(desktop) {
    width: rem-calc(249);
  }
}

.red {
  background-color: #fb7e7a;
}

.yellow {
  background-color: #ffd27c;
}

.green {
  background-color: #7bd56e;
}

.primary {
  background-color: #4fb9de;;
}

.remaining {
  background-color: rgba(153, 164, 174, 0.2);
}
</style>
